import { doDownload, downloadAction, uploadAction } from '../../../../utils/actions'
import { debounce } from '../../../../utils/debounce'
import { getDownloadContent } from '../../../../utils/fns'
import { APP_CONFIG } from '../../common/constants'
import { migrateJSONUpload } from '../../common/fns'
import { postCalculation } from '../actions/calculation.action'
import { inputActions, selectInputState } from '../slices/input.slice'
import { outputActions, selectOutputState } from '../slices/output.slice'

export const CALCULATION_DELAY = 500 // ms

const debouncedCalculation = debounce(({ getState, dispatch }) => {
  const state = getState()
  const input = selectInputState(state)

  dispatch(postCalculation(input))
}, CALCULATION_DELAY)

const handleAppEvents = (store) => (next) => (action) => {
  next(action)

  switch (action.type) {
    case inputActions.modifyCalculation.type:
    case inputActions.updateCalculation.type: {
      debouncedCalculation(store)
      break
    }
    case uploadAction.type: {
      let uploadState = action.payload
      const { searchValue, showAllModels, sortBy, ...inputState } = selectInputState(uploadState)

      if (uploadState.appVersion < APP_CONFIG.appVersion) {
        uploadState = migrateJSONUpload(inputState)
      } else {
        uploadState = inputState
      }

      store.dispatch(inputActions.updateCalculation(uploadState))
      store.dispatch(outputActions.updateInput({ searchValue, showAllModels, sortBy }))
      break
    }
    case downloadAction.type: {
      const state = store.getState()
      const inputState = selectInputState(state)
      const outputState = selectOutputState(state)
      const downloadContent = getDownloadContent(inputState, outputState, APP_CONFIG)
      doDownload(downloadContent, APP_CONFIG.downloadFileName)
      break
    }

    default:
      break
  }
}

export default handleAppEvents
